import { useDecision } from '@optimizely/react-sdk'
import { useSalesPageConfig } from '@space-shell/common/hooks/useSalesPageConfig'
import { RoutesPaths } from '@space-shell/core/router'
import { useMatch } from 'react-router-dom'

import Header from './header'
import HeaderProductPage from './headerProductPage'
import type { StructureHeaderProps } from './types'

const HeaderWrapper = ({ children, ...props }: StructureHeaderProps) => {
  const [productPageNewBannerFF] = useDecision('mex_product_page_new_banner')
  const salesPageConfig = useSalesPageConfig()
  const isClassroom = useMatch(`${RoutesPaths.HOME}${RoutesPaths.CONTENT_CONSUME}`)
  const showNewHeaderProductPage =
    (productPageNewBannerFF?.enabled && isClassroom) || salesPageConfig.canShowProductPageHeader

  if (showNewHeaderProductPage) {
    return <HeaderProductPage {...props}>{children}</HeaderProductPage>
  }

  return <Header {...props}>{children}</Header>
}

export default HeaderWrapper
